import React, { useContext } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button,
    Box,
} from '@mui/material';
import { Link } from 'react-router-dom';
import PositionedMenu from './accountMenu';
import { UserContext } from '../auth/auth-context';
import FloatingBusinessIndicator from './floatingBusinessIndicator';
import { TrialNotification } from '../../util/utils';
import { StyledLink } from '../../assets/css/styledComponent';
import { Link as RouterLink } from 'react-router-dom';
import { WalletMenuItem } from '../tip/walletMenuItem';
import HideOnScroll from '../../util/viewHelpers';

const BusinessHeader = () => {
    const { providerUser } = useContext(UserContext);

    const navLinkSx = {
        color: 'white',
        fontSize: { xs: '0.8rem', sm: '1rem' },
        whiteSpace: 'nowrap',
    };

    const StartFreeTrialButton = () => (
        <Button
            component={Link}
            to="/start-free-trial"
            variant="contained"
            color="primary"
            sx={{ ...navLinkSx, fontWeight: 'bold', ml: 1 }}
        >
            Start Free Trial
        </Button>
    );

    return (
        <>
            <HideOnScroll>

                <AppBar position="fixed" sx={{ backgroundColor: '#333' }}>
                    <Toolbar
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                        }}
                    >
                        {/* Small screen row: Hamburger space + For Customer + Trial Notification */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                pl: { xs: '48px', sm: '64px' }, // Space for hamburger
                                pr: { xs: 1, sm: 0 },
                                position: 'relative',
                                top: { xs: 6, sm: 25 },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{

                                }}
                            >
                                <Link
                                    to="/"
                                    style={{
                                        textDecoration: 'none',
                                        color: 'white',
                                    }}
                                >
                                    For Customer
                                </Link>
                            </Typography>

                            {/* Trial Notification (visible only on xs) */}
                            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                                <StyledLink
                                    component={RouterLink}
                                    to="/biz/pricing"
                                    sx={{ color: 'white' }}
                                    underline="none"
                                >
                                    <TrialNotification />
                                </StyledLink>
                            </Box>
                        </Box>

                        {/* Right Section: Trial (sm+) + other nav items */}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: { xs: 'flex-end', sm: 'center' },
                                justifyContent: 'flex-end',
                                flexGrow: 1,
                                gap: { xs: 1, sm: 1.5 },
                                pr: { xs: 1, sm: 3 },
                            }}
                        >
                            <WalletMenuItem />
                            {/* Trial Notification (sm and up) */}
                            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                <StyledLink
                                    component={RouterLink}
                                    to="/biz/pricing"
                                    sx={{ color: 'white' }}
                                    underline="none"
                                    state={{ from: window.location.href }}
                                >
                                    <TrialNotification />
                                </StyledLink>
                            </Box>

                            {/* Main nav items */}
                            <Box >
                                <StyledLink
                                    component={RouterLink}
                                    to="/biz/pricing"
                                    state={{ from: window.location.href }}
                                    sx={navLinkSx}
                                    underline="none"
                                >
                                    Pricing
                                </StyledLink>

                                {providerUser.userId && !providerUser.defaultBusinessId && (
                                    <StyledLink
                                        href="/biz/business"
                                        sx={navLinkSx}
                                        underline="none"
                                    >
                                        Create your first business profile
                                    </StyledLink>
                                )}

                                {!providerUser.userId && (
                                    <>
                                        <StyledLink href="/login" sx={navLinkSx} underline="none">
                                            Login/Register
                                        </StyledLink>
                                        <StartFreeTrialButton />
                                    </>
                                )}

                                {providerUser.userId && (
                                    <IconButton
                                        edge="end"
                                        color="inherit"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                    >
                                        <PositionedMenu menu="Business" />
                                    </IconButton>
                                )}
                            </Box>
                        </Box>
                    </Toolbar>
                </AppBar> 
            </HideOnScroll>
            <FloatingBusinessIndicator />
        </>
    );
};

export default BusinessHeader;
